import { useQuery } from '@tanstack/react-query';
import { fetch } from '../fetch';

export function useTasksQuery(analysisSlug: string) {
  return useQuery({
    queryKey: ['tasks', analysisSlug],
    queryFn: async () => {
      const response = await fetch(`/analysis/${analysisSlug}/tasks`, {
        method: 'GET'
      });
      const data = await response.json();
      return data;
    }
  });
}
